import { Layout } from "antd";
import { images } from "../routes/ImageRoutes";
import stylesCss from "./css/headerComponent.module.css";
import { Link } from "react-router-dom";

const { Header } = Layout;

const HeaderComponent = () => {
    return (
        <>
            <Header className={stylesCss.headerStyle}>
                <Link
                    style={{ color: "#1786ff", display: 'flex'}}
                    to={"http://mega.mx/"}
                    target='_blank'
                    className={stylesCss.logoMegacable}
                >
                    <img
                        src={images.logoMega}
                        alt="MEGA"
                    />
                </Link>
            </Header>
        </>
    );
};

export default HeaderComponent;